import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import { setSpinnerLoading } from './Redux/modal';

export const autoCollectionSaveInBilling = true;
export const licenceExpired_alert =
  'Your license has expired. Please contact support@geniusoffice.com, +91 85589 51962 for renewal. Visit https://www.geniusoffice.com.';
export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const mobileRegex = /^[6-9]\d{9}$/;
export const templateForList = [
  'invoice',
  'otp',
  'order_accepted',
  'order_dispatch',
  'delivery_otp',
  'order_delivered',
  'order_rejected',
  'tailoring_pormotional_media',
  'tailoring_pormotional_text',
  'routebilling_pormotional_media',
  'routebilling_pormotional_text',
  'support_msg_text',
  'License expired_text',
  'other',
];
export const FontSizeWidth = (width) => {
  if (width < 500) {
    return 11;
  }
  if (width < 1281) {
    return 12;
  } else {
    return 14;
  }
};
export const primaryColor = '#0d0d0d';
export const primaryColorBlue = '#4d5be5';
export const getMessageWallet = (companyEmail, token, sms, dispatch) => {
  return new Promise((resolve, reject) => {
    CallAPIPromise(
      `/api/whatsApp/loadMessageBalance`,
      {
        company_email: companyEmail,
      },
      token
    )
      .then((res) => {
        console.log(res);
        if (!res.data.error) {
          if (res.data.response[0]) {
            if (sms) {
              resolve(
                Number(res.data.response[0].sms_balance),
                res.data.response[0]
              );
            } else {
              if (res.data.response[0].whatsapp_balance < 1) {
                dispatch(setSpinnerLoading(false));
              }
              resolve(
                Number(res.data.response[0].whatsapp_balance),
                res.data.response[0]
              );
            }
          } else {
            dispatch(setSpinnerLoading(false));
            resolve(0);
          }
        } else {
          resolve(0);
        }
      })
      .catch((err) => {
        console.log(err);
        reject(0);
      });
  });
};
